import { useCookieConsent } from '@izimi/core';
import { useConfigurationLinks } from 'core/modules/public';

export const CookieProvider = () => {
  const { cookieUrl } = useConfigurationLinks();
  useCookieConsent(cookieUrl);

  return null;
};
